import { render, staticRenderFns } from "./MapPointPicker.vue?vue&type=template&id=5bcda6b6&scoped=true"
import script from "./MapPointPicker.vue?vue&type=script&lang=js"
export * from "./MapPointPicker.vue?vue&type=script&lang=js"
import style0 from "./MapPointPicker.vue?vue&type=style&index=0&id=5bcda6b6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bcda6b6",
  null
  
)

export default component.exports